// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as EventFeed$LiveRoom from "./EventFeed.bs.js";
import * as PropSpread$LiveRoom from "../../components/PropSpread.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as Utils_Bidding$LiveRoom from "../../Utils/Utils_Bidding.bs.js";
import * as FeedMessageBox$LiveRoom from "../../components/FeedMessageBox.bs.js";
import * as PlaceBidButton$LiveRoom from "./PlaceBidButton.bs.js";
import * as StyleConstants$LiveRoom from "../../styles/StyleConstants.bs.js";
import * as SubmitIdentificationModal$LiveRoom from "../../components/Modal/SubmitIdentificationModal.bs.js";

function FeedSection$Feed(props) {
  var lot = props.lot;
  var match = lot.currentLotCardLotFragment.latestBid.bid;
  var isWinner = match !== undefined ? match.bidState === "Won" : false;
  var match$1 = Belt_Option.map(lot.currentLotCardLotFragment.bidState, (function (bidState) {
          return bidState.bidType;
        }));
  return React.createElement(EventFeed$LiveRoom.make, {
              lotId: lot.lotDetailsLotFragment.lotId,
              lotNr: lot.lotDetailsLotFragment.lotNumber,
              lotIsLive: match$1 !== undefined && typeof match$1 === "object" && match$1.NAME === "LiveBidType" ? match$1.VAL.liveBidPhase === "Live" : false,
              currency: props.currency,
              eventFeedHeight: props.eventFeedHeight,
              isWinner: isWinner,
              direction: props.direction,
              className: props.className
            });
}

var Feed = {
  make: FeedSection$Feed
};

function FeedSection$CTASection(props) {
  var showSelectAccount = props.showSelectAccount;
  var lot = props.lot;
  var fragment = props.fragment;
  var match = React.useState(function () {
        return /* NoModal */0;
      });
  var setModalToShow = match[1];
  var modalToShow = match[0];
  var isBidCapReached = React.useMemo((function () {
          return Utils_Bidding$LiveRoom.isBidCapReached(fragment.enrollment.bidCap.bidCap, Belt_Option.mapWithDefault(lot.feedLotMessageBoxFragment.bidState, undefined, (function (x) {
                            return x.bidAsk;
                          })), lot.feedLotMessageBoxFragment.latestBid.bid);
        }), [
        fragment.enrollment.bidCap.bidCap,
        lot.feedLotMessageBoxFragment.bidState,
        props.selectedLotId
      ]);
  return React.createElement("div", {
              className: props.className
            }, React.createElement(FeedMessageBox$LiveRoom.make, {
                  fragment: lot.feedLotMessageBoxFragment,
                  isBidCapReached: isBidCapReached
                }), React.createElement(PlaceBidButton$LiveRoom.make, {
                  auctionFragment: fragment.placeBidButtonAuctionFragment,
                  lotFragment: lot.placeBidButtonLotFragment,
                  authToken: props.authToken,
                  showSelectAccountModal: (function (param) {
                      Curry._1(showSelectAccount, undefined);
                    }),
                  isBidCapReached: isBidCapReached,
                  socketConnected: true,
                  showIncompleteRegistrationModal: props.showIncompleteRegistrationModal,
                  showSubmitIdentificationModal: (function (modalType) {
                      Curry._1(setModalToShow, (function (param) {
                              return /* SubmitIdentificationModal */{
                                      _0: modalType
                                    };
                            }));
                    })
                }), modalToShow ? React.createElement(SubmitIdentificationModal$LiveRoom.make, {
                    onClose: (function (param) {
                        Curry._1(setModalToShow, (function (param) {
                                return /* NoModal */0;
                              }));
                      }),
                    modalType: modalToShow._0,
                    saleNumber: fragment.sapSaleNumber
                  }) : null);
}

var CTASection = {
  make: FeedSection$CTASection
};

function FeedSection(props) {
  var lot = props.lot;
  var fragment = props.fragment;
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.height(Css.pct(100)),
                    tl: {
                      hd: CommonStyles$LiveRoom.mediaV2(/* DesktopAndTabletLandscape */4, {
                            hd: StyleConstants$LiveRoom.defaultBorder("left", undefined, undefined),
                            tl: /* [] */0
                          }),
                      tl: {
                        hd: Css.display("grid"),
                        tl: {
                          hd: Css.gridTemplateRows({
                                hd: {
                                  NAME: "fr",
                                  VAL: 1.0
                                },
                                tl: {
                                  hd: Css.auto,
                                  tl: /* [] */0
                                }
                              }),
                          tl: {
                            hd: Css.gridTemplateAreas({
                                  NAME: "areas",
                                  VAL: [
                                    "Feed",
                                    "FeedBottom"
                                  ]
                                }),
                            tl: {
                              hd: Css.padding(Css.px(8)),
                              tl: {
                                hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                                      hd: Css.height(Css.pct(100)),
                                      tl: {
                                        hd: Css.overflowY("hidden"),
                                        tl: /* [] */0
                                      }
                                    }),
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }
                    }
                  }),
              id: "feed-section"
            }, React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.gridArea({
                              NAME: "ident",
                              VAL: "Feed"
                            }),
                        tl: {
                          hd: Css.overflowY("hidden"),
                          tl: /* [] */0
                        }
                      }),
                  id: "feed-section-main"
                }, React.createElement(FeedSection$Feed, {
                      currency: fragment.currency,
                      lot: lot,
                      eventFeedHeight: props.eventFeedHeight
                    })), React.createElement(PropSpread$LiveRoom.make, {
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "placeBidSection"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.gridArea({
                                    NAME: "ident",
                                    VAL: "FeedBottom"
                                  }),
                              tl: /* [] */0
                            })
                      }, React.createElement(FeedSection$CTASection, {
                            fragment: fragment,
                            lot: lot,
                            showSelectAccount: props.showSelectAccount,
                            showIncompleteRegistrationModal: props.showIncompleteRegistrationModal,
                            authToken: props.authToken,
                            selectedLotId: props.selectedLotId
                          }))
                }));
}

var make = FeedSection;

export {
  Feed ,
  CTASection ,
  make ,
}
/* Css Not a pure module */
